import axios from '../lib/axios'
import { buildUrlString } from '@!/Util'

export const getTopFreeFeaturesApi = async (safeSearch, device) => {
  const url = buildUrlString('/api/v1/free_features/top', { safe_search: safeSearch, device })

  return await axios.get(url)
}
